<template>
  <b-col
    class="form-box card-data-block"
    :class="customClass"
  >
    <div
      v-if="patient"
      class="structure"
      :class="{ 'section-highlight': highlightSection }"
    >
      <span class="structure__heading"><i
        class="far fa-id-card-alt mr-2"
        aria-hidden="true"
      />{{ $tc('global.identifier', 2) }}</span>
      <b-row class="mt-1">
        <b-col
          v-for="(identifier) in identifiers"
          :key="identifier.value.paiIdentifier"
          :class="{ 'highlight': hasDiff(identifier.value) }"
          lg="4"
        >
          <div class="d-flex align-items-center">
            <b-form-checkbox
              v-if="showPatientIdentifierCheckbox(identifier.value)"
              v-model="identifier.selected"
              class="m-0"
              :unchecked-value="null"
            />
            <small>
              {{ identifier.value.identifierType.name }}
              <i
                v-if="showPatientCenterName(identifier.value.center)"
                v-tooltip="identifier.value.center.name"
                class="ml-1 far fa-clinic-medical"
                aria-hidden="true"
              />
            </small>
          </div>
          <h4
            :class="{ 'item-selected': setItemSelectedClassToPatientIdentifier(identifier) }"
            class="collapsable-card-title inside"
          >
            {{ identifier.value.paiIdentifier }}
          </h4>
        </b-col>
      </b-row>
    </div>
  </b-col>
</template>

<script>
import { PATIENT_AUTOGENERATED_GLOBAL_ID } from '@/api/resources/PatientIdentifierResource'

export default {
    name: 'PatientIdentifiersCard',
    props: {
        patient: { type: Object, default: null },
        customClass: { type: Array },
        identifiersDiff: { type: Array },
        localPatient: { type: Boolean, default: false },
        integrationPatient: { type: Boolean, default: false },
        continueWithCaseCreation: { type: Boolean, default: false }
    },
    data() {
        return {
            identifiers: [],
            internalIdentifiers: []
        }
    },
    computed: {
        highlightSection() {
            return this.identifiersDiff?.length
        }
    },
    mounted() {
        this.identifiers = []
        this.patient.patientIdentifiers.forEach((patientIdentifier) => {
            const identifier = {
                value: patientIdentifier,
                selected: this.hasDiff(patientIdentifier)
            }
            this.identifiers.push(identifier)
        })
    },
    methods: {
        showPatientCenterName(identifierCenterValue) {
            return !!identifierCenterValue
        },

        setItemSelectedClassToPatientIdentifier(identifier) {
            return identifier.selected && this.integrationPatient && this.hasDiff(identifier.value)
        },

        showPatientIdentifierCheckbox(value) {
            return this.continueWithCaseCreation ? this.integrationPatient && this.hasDiff(value) : this.integrationPatient
        },

        hasDiff(identifier) {
            let hasDiff = !!this.identifiersDiff.find(duplicatedIdentifier => {
                let hasSameIdentifier = (duplicatedIdentifier.paiIdentifier === identifier.paiIdentifier)
                if (this.localPatient) {
                    hasSameIdentifier = !hasSameIdentifier
                }
                return hasSameIdentifier &&
                    (duplicatedIdentifier.identifierType.idtId === identifier.identifierType.idtId)
            })
            if (identifier.identifierType.code === PATIENT_AUTOGENERATED_GLOBAL_ID) {
                hasDiff = false
            }
            return hasDiff
        }
    }
}
</script>

<style scoped>

</style>
